import { render, staticRenderFns } from "./process.vue?vue&type=template&id=1d215908&scoped=true"
import script from "./process.vue?vue&type=script&lang=js"
export * from "./process.vue?vue&type=script&lang=js"
import style0 from "./process.vue?vue&type=style&index=0&id=1d215908&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d215908",
  null
  
)

export default component.exports